// Web stub for react-native-maps (native-only lib). Keeps the online
// build from crashing at import; renders a neutral placeholder box.
import React from "react";
import { View, Text } from "react-native";

const Box = ({ children, style }) => (
  <View
    style={[
      {
        backgroundColor: "#E9EEF5",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      },
      style,
    ]}
  >
    <Text style={{ color: "#8F92A1", fontSize: 12 }}>Map preview</Text>
    {children}
  </View>
);

export const Marker = () => null;
export const Callout = ({ children }) => children || null;
export const PROVIDER_GOOGLE = "google";
export const PROVIDER_DEFAULT = undefined;

const MapView = Box;
export default MapView;
